import { useTheme } from "@emotion/react";
import { Box, Grid, Stack } from "@mui/material";
import TitleComponent from "../../components/widgets/titleComponent";
import { useTranslation } from "react-i18next";
import BlogDetails from "./blogDetails";
import blogData from '../../assets/data/blogs.json';
import NavigationLayout from '../navigation/navigationLayout';
import FooterLayout from '../footer/footerLayout';
import { useCallback, useEffect, useState } from "react";
import PaginationComponent from "../../components/widgets/paginationComponent";

const ITEMS_PER_PAGE = 9;

const BlogsLayout = () => {
    const theme = useTheme();
    const {t} = useTranslation();

    const [activePage, setActivePage] = useState(0);

    const changePage = useCallback((page) => {
        setActivePage(page);
    }, []);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <NavigationLayout />

            <Box
                className="sectionSpacing"
                width='100%'
                sx={{
                    backgroundColor: theme.palette.background.default,
                    pt: {xs: 15, md: 20, lg: 25}
                }}
            >
                <Stack
                    direction='column'
                    justifyContent='center'
                    alignItems='center'
                    px='5%'
                >
                    <TitleComponent 
                        title={t('blogs.title')}
                        description={t('blogs.description')}
                        centerMode
                    />

                    {/* Medium Platform Introduction */}
                    <BlogDetails 
                        data={{
                            "title": t('blogs.blogPlatform.title'),
                            "description": t('blogs.blogPlatform.description'),
                            "image": "/images/blogs/mediumBlog.png",
                            "src": blogData.profile
                        }} 
                        featuredBlog
                        customFeatureTag={t('blogs.blogPlatform.tag')}
                        readActionTxt={t('blogs.blogPlatform.follow')}
                    />

                    {/* All Blogs */}
                    <Grid
                        direction='row'
                        justifyContent='start'
                        alignItems='start'
                        pt={{xs: 2, md: 10}}
                        container
                        width='100%'
                        spacing={{xs: 4, md: 5}}
                    >
                        <Grid 
                            size={12}
                            sx={{
                                mb: -5
                            }}
                        >
                            <TitleComponent 
                                title={t('blogs.allBlogs')}
                            />
                        </Grid>

                        {
                            blogData.blogs.slice(activePage * ITEMS_PER_PAGE, ITEMS_PER_PAGE * (1 + activePage)).map((item, index) => {
                                return <Grid 
                                    size={{xs: 12, md: 4}}
                                    key={index}
                                    sx={{
                                        pt: {xs: index === 0 ? 2 : 0, md: 0}
                                    }}
                                >
                                    <BlogDetails data={item}/>
                                </Grid>
                            })
                        }
                    </Grid>

                    {/* Pagination */}
                    <PaginationComponent 
                        totalItems={blogData.blogs.length}
                        itemsPerPage={ITEMS_PER_PAGE}
                        activePage={activePage}
                        onPageChange={changePage}
                    />
                </Stack>
            </Box>

            <FooterLayout />
        </>
    );
}

export default BlogsLayout;